import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function AboutKarina() {
  return <section className="py-24 px-6 bg-white relative overflow-hidden" data-id="element-14">
      {/* Subtle decorative element */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-nude/40 rounded-full filter blur-3xl pointer-events-none" data-id="element-15"></div>

      <div className="max-w-6xl mx-auto" data-id="element-16">
        {/* Trust badge */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center text-xs tracking-[0.3em] uppercase text-gold font-medium mb-16" data-id="element-17">
          Trusted Beauty Essentials by Karina Perez
        </motion.p>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-18">
          {/* Left — Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-19">
            <div className="aspect-[3/4] bg-nude rounded-2xl overflow-hidden relative" data-id="element-20">
              <img src="https://cdn.magicpatterns.com/uploads/eCLJp1LWWNqR8DRoTMJp1p/IMG_4514.jpg" alt="Karina Perez — Fundadora de Alexa Beauty" className="w-full h-full object-cover object-top" data-id="element-21" />
            </div>
            {/* Decorative frame accent */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-gold/20 rounded-2xl -z-10" data-id="element-22"></div>
          </motion.div>

          {/* Right — Text */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative z-10" data-id="element-23">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-luxury-black mb-8 leading-tight" data-id="element-24">
              CONOCE A <br data-id="element-25" />
              <span className="italic text-rosado" data-id="element-26">KARINA PEREZ</span>
            </h2>

            <div className="space-y-5 text-gray-600 font-sans font-light leading-relaxed text-base md:text-lg" data-id="element-27">
              <p data-id="element-28">
                La pasión de Karina por el beauty business comenzó realzando la
                belleza de la mirada de cada chica, entendiendo que pequeños
                detalles pueden transformar la seguridad y confianza de una
                mujer.
              </p>
              <p data-id="element-29">
                Hoy comparte tips reales y efectivos de skincare y belleza,
                ayudando a mujeres a cuidar su piel de forma simple, elegante y
                sin complicaciones.
              </p>
              <p data-id="element-30">
                Karina cree en resultados visibles, en la honestidad y en que
                sentirte bien contigo misma lo cambia todo.
              </p>
              <p data-id="element-31">
                Cada producto de su marca ha sido seleccionado con intención,
                calidad y amor por los detalles, pensado para mujeres que desean
                verse y sentirse espectaculares todos los días.
              </p>
            </div>

            {/* Featured quote */}
            <div className="my-10 py-6 border-l-2 border-gold pl-6" data-id="element-32">
              <p className="font-serif text-xl md:text-2xl italic text-luxury-black leading-relaxed" data-id="element-33">
                "La verdadera belleza comienza cuando te sientes segura de ti."
              </p>
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="bg-luxury-black hover:bg-luxury-dark text-white font-sans font-medium text-sm tracking-widest uppercase px-10 py-4 rounded-sm transition-colors duration-300 mb-6" data-id="element-34">
              DESCUBRIR LA COLECCIÓN
            </motion.button>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6 text-xs text-gray-400 font-sans tracking-wide" data-id="element-35">
              <span className="flex items-center gap-1.5" data-id="element-36">
                <Sparkles className="w-3.5 h-3.5 text-gold" data-id="element-37" /> Productos
                seleccionados por Karina
              </span>
              <span className="flex items-center gap-1.5" data-id="element-38">
                <Sparkles className="w-3.5 h-3.5 text-gold" data-id="element-39" /> Calidad premium
              </span>
              <span className="flex items-center gap-1.5" data-id="element-40">
                <Sparkles className="w-3.5 h-3.5 text-gold" data-id="element-41" /> Belleza real sin
                complicaciones
              </span>
            </div>
          </motion.div>
        </div>

        {/* Bottom impact line */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mt-20 pt-16 border-t border-gray-100" data-id="element-42">
          <h3 className="text-2xl md:text-3xl font-serif text-luxury-black mb-3" data-id="element-43">
            KARINA PEREZ NO SOLO CREÓ UNA MARCA…
          </h3>
          <p className="text-lg text-gray-500 font-sans font-light max-w-2xl mx-auto" data-id="element-44">
            Creó una experiencia pensada para mujeres que aman cuidarse, verse
            hermosas y elegir productos que realmente aporten valor.
          </p>
        </motion.div>
      </div>
    </section>;
}